import { render } from "./GroupMaster.vue?vue&type=template&id=4f575afa&scoped=true"
import script from "./GroupMaster.vue?vue&type=script&lang=js"
export * from "./GroupMaster.vue?vue&type=script&lang=js"

import "./GroupMaster.vue?vue&type=style&index=0&id=4f575afa&scoped=true&lang=scss"

import exportComponent from "D:\\CTS_SURAJ\\MAHASBM\\MAHASBM-CODE\\ui-code\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f575afa"]])

export default __exports__